import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["isCollapsed", "collapsedHeight", "children"];
import { animated, useSpring } from '@react-spring/web';
import PropTypes from 'prop-types';
import React, { useEffect, useImperativeHandle, useRef, useState } from 'react';
import { Box } from '../Layout';
const AnimatedBox = animated(Box);
export const Collapse = React.forwardRef(function Collapse(_ref, ref) {
  let {
      isCollapsed,
      collapsedHeight,
      children
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  const collapseRef = useRef();
  const [height, setFullHeight] = useState(0);
  useImperativeHandle(ref, () => collapseRef.current);
  useEffect(() => setFullHeight(collapseRef.current.scrollHeight), [children]);
  const maxCollapsedHeight = collapsedHeight > height ? height : collapsedHeight;
  const listSpring = useSpring({
    height: isCollapsed ? maxCollapsedHeight : height
  });
  return React.createElement(AnimatedBox, _extends({
    ref: collapseRef,
    overflow: "hidden",
    style: {
      height: collapseRef.current ? listSpring.height : 'auto'
    }
  }, rest), children);
});
Collapse.propTypes = process.env.NODE_ENV !== "production" ? {
  isCollapsed: PropTypes.bool.isRequired,
  collapsedHeight: PropTypes.number.isRequired,
  children: PropTypes.node.isRequired
} : {};